export default __webpack_public_path__ + "static/media/panda.7667737b.PNG";